import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { NewsDeleteSVG } from '@common_components/svg/newsDelete.svg';

const NewsDeleteIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <NewsDeleteSVG/>
    </div>
  );
};

export { NewsDeleteIcon };
